import { Button } from "@/components/ui/button";

interface MicrosoftLoginButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const MicrosoftLoginButton = ({ onClick, disabled }: MicrosoftLoginButtonProps) => {
  return (
    <Button
      type="button"
      variant="outline"
      className="w-full"
      onClick={onClick}
      disabled={disabled}
    >
      <svg className="h-5 w-5 mr-2" viewBox="0 0 24 24" fill="none">
        <path d="M11.4 11.4H0V0h11.4v11.4z" fill="#F25022"/>
        <path d="M24 11.4H12.6V0H24v11.4z" fill="#7FBA00"/>
        <path d="M11.4 24H0V12.6h11.4V24z" fill="#00BCF2"/>
        <path d="M24 24H12.6V12.6H24V24z" fill="#FFB900"/>
      </svg>
      Continue with Microsoft
    </Button>
  );
};